import { useCallback } from "react";
import { useLocation } from "wouter";
import {
  DEFAULT_SECTION,
  SETTINGS_BASE_PATH,
  isSettingsSection,
} from "../constants";
import { SettingsSectionId } from "../types";

export const useSettingsNavigation = (section?: string) => {
  const [, setLocation] = useLocation();

  const hasValidSection = isSettingsSection(section);
  const activeSection: SettingsSectionId = hasValidSection
    ? section
    : DEFAULT_SECTION;

  const redirectToDefault = useCallback(() => {
    setLocation(`${SETTINGS_BASE_PATH}/${DEFAULT_SECTION}`, { replace: true });
  }, [setLocation]);

  return {
    activeSection,
    hasValidSection,
    redirectToDefault,
  };
};
